<template>
  <v-app>
    <v-toolbar app>
      <v-toolbar-title class="headline text-uppercase">
        <span>ConnectEvents.io </span>
        <span class="font-weight-light">Tools</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>

    <v-content>
      <ImageGenerator/>
    </v-content>
  </v-app>
</template>

<script>
import ImageGenerator from './components/ImageGenerator'

export default {
  name: 'App',
  components: {
      ImageGenerator
  },
  data () {
    return {
      //
    }
  }
}
</script>
